export const invoiceStatusOptions: {name: string, value: string}[] = [
  {name: 'all', value: 'all'},
  {name: 'pending-payment', value: 'pending'},
  {name: 'paid-s', value: 'paid'},
];